/**
 * ID used in the drag DataTransfer object to store items ids currently dragged
 */
export const DRAG_ITEM_KEY = 'drag-item';

/**
 * ID used in the drag DataTransfer object to store the HTML id of the dragged element
 */
export const DRAG_ITEM_ID_KEY = 'drag-item-id';
